import MixMapCtl from '../mainPage/map/mixmap/MixMapCtl';
// ../map/mixmap/MixMapCtl
import GModule from '@/page/globalModule';

function createModule() {
    const MixMapModule = new MixMapCtl({
        showSearch: false,
        showZoomTool: false,
        showBottomBar: false,
        talksE: false,
        bottomShowDefault: false,
        showFly: true,
    }).init();

    return {
        AircraftModule: GModule.AircraftModule,
        MixMapModule,
    };
}

export default createModule;
